import { createContext, useContext, useState, useEffect } from "react";
import useDataFetcher from "../hooks/useDataFetcher";

const StaticInfoContext = createContext();

export const StaticInfoProvider = ({ children }) => {
  const [staticInfo, setStaticInfo] = useState({
    hero: {
      title: "GYK Hukuk Sizlerle",
      subtitle: "Sizlerleyiz gerçekten",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed ac justo euismod, cursus libero nec, tincidunt nunc. Nullam euismod, odio nec bibendum varius, urna nunc ultrices justo, vel tincidunt metus libero vel nunc.",
    },
  });

  const { data, loading, error } = useDataFetcher(
    "http://localhost:5000/api/StaticPagesInfoes"
  );

  useEffect(() => {
    if (data !== null && loading === false && error === null) {
      setStaticInfo({
        hero: {
          title: data.heroHeader,
          subtitle: data.heroSubheader,
          description: data.heroText,
        },
      });
    }
  }, [data, loading, error]);

  return (
    <StaticInfoContext.Provider value={staticInfo}>
      {children}
    </StaticInfoContext.Provider>
  );
};

export const useStaticInfo = () => useContext(StaticInfoContext);
